// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","laptopXS":"1024px","laptopS":"1280px","laptopM":"1440px","laptopL":"1920px","laptopXL":"2560px"};